export type SourceAction = 'pause' | 'reactivate' | 'cancel' | 'remove';

type SourceActionBody =
  | { sourceId: string; action: 'pause' | 'reactivate' | 'cancel' }
  | { sourceId: string; action: 'disconnect'; deleteData: true };

/**
 * Maps a UI source action to the POST body shape the backend expects.
 * `remove` → disconnect + deleteData (full revoke); others pass through as-is.
 */
export function buildSourceActionBody(id: string, action: SourceAction): SourceActionBody {
  if (action === 'remove') {
    return { sourceId: id, action: 'disconnect', deleteData: true };
  }
  return { sourceId: id, action };
}
